/**
 * Inc5 · Comparación de calificaciones entre periodos.
 *
 * Se apoya en un esquema de correspondencias declarado a mano, porque dos
 * factores homónimos de modelos distintos pueden medir cosas distintas. Un
 * componente sin correspondencia no aparece en el comparativo.
 *
 * Store Pinia: estado compartido del módulo y orquestación de sus servicios.
 * Las vistas no llaman a `http` ni a los servicios directamente; pasan por aquí.
 * Los servicios no lanzan, así que las acciones interpretan valores neutros
 * (`[]`, `null`, `false`) como fallo.
 */

import { defineStore } from 'pinia'
import type { ComparacionCalificacion } from '@/interfaces/ComparacionCalificacion'
import { getComparacionService, type OpcionesComparacion } from '@/services/ComparacionService'

/** Store `comparacion`. Ver la cabecera del archivo para el contrato del módulo. */
export const useGestionComparacion = defineStore('comparacion', {
  state: () => ({
    comparacion: null as ComparacionCalificacion | null,
    cargando: false,
    error: '' as string,
    status: 0
  }),

  actions: {
    async cargar(idEjecucion: number, opciones: OpcionesComparacion = {}): Promise<void> {
      this.cargando = true
      this.error = ''
      const res = await getComparacionService(idEjecucion, opciones)
      this.status = res.status
      if (res.ok) {
        this.comparacion = res.data ?? null
      } else {
        this.comparacion = null
        this.error = res.error ?? 'Error al cargar la comparación'
      }
      this.cargando = false
    },

    limpiar(): void {
      this.comparacion = null
      this.error = ''
      this.status = 0
    }
  }
})
